import Service from "../../../Services/index";
import moment from "moment";

const SaveExportation = {
    namespaced: true,
    state: {
        SaveExportationList: [],
        invoices : [],
        form: {
            invoice: null,
            invoice_id : "",
            invoice_number : "",
            payment_type_id: [],
            transaction_id: [],
            amount: "",
            image_file: "",
            remark  :"",
            old_invoice : null,
            old_invoice_id : "",
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        search:{
            invoice_id: "",
            date: "",
            seller: "",
        }
    },
    mutations: {
        GET_SAVE_EXPORTATION: (state, res) => {
            state.SaveExportationList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        GET_SAVE_EXPORTATION_BY_ID:(state,res)=>{
            state.form = res;
            if(res.invoice){
                state.form.invoice_number = res.invoice.invoice_id
            }
        },
        CLEAR_FORM_DATA: state => {
            state.form = {
                invoice: null,
                invoice_id : "",
                invoice_number : "",
                payment_type_id: [],
                transaction_id: [],
                amount: "",
                image_file: "",
                remark  :"",
                old_invoice : null,
                old_invoice_id : "",
            };
        },
        CLEAR_SEARCH : (state) =>{
            state.search = {
                invoice_id: "",
                date: "",
                seller: ""
            }
        },
    },
    actions: {
        setSaveExportation({commit}, page = 1) {
            return Service.SaveExportation.getSaveExportation(page).then(res => {
                commit("GET_SAVE_EXPORTATION", res);
            });
        },
        saveSaveExportation({commit},{id,data}){
            console.log(id);
            console.log(data);
            if(!id){
                return Service.SaveExportation.createSaveExportation(data).then(res=>{
                    console.log("create");
                });
            }
            else{
                return Service.SaveExportation.updateSaveExportation(id,data).then(res=>{
                    console.log("update");
                });
            }
        },
        showSaveExportation({commit},id){
            return Service.SaveExportation.showSaveExportation(id).then(res=>{
                commit("GET_SAVE_EXPORTATION_BY_ID",res);
            })
        },
        clearFormData({ commit }) {
            commit("CLEAR_FORM_DATA");
        },
        search({commit},data){
            return Service.SaveExportation.searchSaveExportation(data).then(res=>{
                commit("GET_SAVE_EXPORTATION",res)
            })
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        },
        getInvoiceByDriver({commit}){
            return Service.SaveExportation.getInvoiceByDriver();
        }
    }
};

export default SaveExportation;